export default "__VITE_ASSET__CVunAidl__"